import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";

export function ListingBanner() {
  return (
    <Link to="/list-your-market" data-testid="home-listing-banner"
      className="ring-fx mb-6 block rounded-2xl transition-transform hover:scale-[1.01]">
      <div className="flex flex-wrap items-center justify-center gap-2 rounded-[13px] bg-[#1a0a2e] px-4 py-3 text-center">
        <Megaphone className="h-5 w-5 shrink-0 text-amber-300" />
        <span className="premium-blink font-display text-base font-black uppercase tracking-wide text-amber-300 md:text-lg">Add Your Market / Listing Here</span>
        <span className="rounded-full bg-[#229ED9] px-3 py-1 text-[11px] font-black uppercase text-white">Instant Approval via AI Telegram Bot</span>
      </div>
    </Link>
  );
}
